import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';

interface InfoDialogData {
  title: string;
  content: string;
  confirmButtonText?: string;
  confirmButtonLabel?: string;
  confirmButtonColor?: string;
  cancelButtonText?: string;
  cancelButtonLabel?: string;
}

@Component({
  selector: 'lib-confirm-dialog',
  imports: [MatDialogModule, MatButtonModule],
  template: `
    <h2 mat-dialog-title class="mat-label-large dialog-title">
      <b>{{ title }}</b>
    </h2>
    <mat-dialog-content class="mat-label-medium content" [innerHTML]="content">
    </mat-dialog-content>
    <mat-dialog-actions>
      <button mat-button mat-dialog-close [attr.aria-label]="cancelButtonLabel">
        {{ cancelButtonText }}
      </button>
      <button
        mat-flat-button
        [attr.color]="confirmButtonColor"
        [mat-dialog-close]="true"
        [attr.aria-label]="confirmButtonLabel"
      >
        {{ confirmButtonText }}
      </button>
    </mat-dialog-actions>
  `,
  styles: `
    @use '@angular/material' as mat;
    @use 'theme' as theme;

    .dialog-title {
      color: mat.get-theme-color(theme.$light-theme, on-surface);
    }

    .content {
      color: mat.get-theme-color(theme.$light-theme, on-primary-container);
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmationDialogComponent {
  private readonly dialogData = inject(MAT_DIALOG_DATA) as InfoDialogData;

  title = this.dialogData.title;
  content = this.dialogData.content;
  confirmButtonText = this.dialogData.confirmButtonText ?? 'Yes';
  confirmButtonLabel = this.dialogData.confirmButtonLabel;
  confirmButtonColor = this.dialogData.confirmButtonColor ?? 'primary';
  cancelButtonText = this.dialogData.cancelButtonText ?? 'No';
  cancelButtonLabel = this.dialogData.cancelButtonLabel;
}
